import React from 'react';
import SampleManagementRouter from './SampleManagementRouter';

export default function SampleManagementPage() {
  return <SampleManagementRouter />;
}